import { render } from "./ServiceTab.vue?vue&type=template&id=c36df948"
import script from "./ServiceTab.vue?vue&type=script&lang=js"
export * from "./ServiceTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__